/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import React from 'react';
import DialogContent from 'wfui-digital-core/es/DialogContent';
import DialogHeader from 'wfui-digital-core/es/DialogHeader';
import DialogFooter from 'wfui-digital-core/es/DialogFooter';
import DialogButtonContainer from 'wfui-digital-core/es/DialogButtonContainer';
import Block from 'wfui-digital-core/es/Block';
import Button from 'wfui-digital-core/es/Button';
import Translatable from 'wfui-digital-core/es/Translatable';
import Fragment from 'wfui-digital-core/es/Fragment';
import Markup from 'wfui-digital-core/es/Markup';
import withStrings from 'wfui-digital-core/es/withStrings';
import styles from './ForeseeContent.less';

var SamlConfirmationContent = function SamlConfirmationContent(_ref) {
  var onDecline = _ref.onDecline,
      onAccept = _ref.onAccept,
      getString = _ref.getString;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogHeader, null, /*#__PURE__*/React.createElement(Markup, {
    content: getString('global.wf.leave.title')
  })), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Block, {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Fragment, {
    id: "foresee-confirm",
    fragmentId: "foresee-confirm"
  }))), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButtonContainer, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(Button, {
    buttonType: "secondary",
    onClick: onDecline
  }, /*#__PURE__*/React.createElement(Translatable, {
    id: "global.cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    onClick: onAccept
  }, /*#__PURE__*/React.createElement(Translatable, {
    id: "global.continue"
  })))));
};

export default withStrings(SamlConfirmationContent);